import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=fa22c80e&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=fa22c80e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa22c80e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa22c80e')) {
      api.createRecord('fa22c80e', component.options)
    } else {
      api.reload('fa22c80e', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=fa22c80e&scoped=true&", function () {
      api.rerender('fa22c80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GX7t4fEGPVG4/JS/comp/CookieBox.vue"
export default component.exports